<template>
  <div class="representManage">
    <div>
      <div>
        <!-- 筛选 -->
        <el-form ref="form" :model="form" :inline="true" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="form.input"
              placeholder="输入姓名或手机号"
              class="setUp-doctor-word"
              clearable
            />
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" :loading="bottonLoading" @click="search" style="width: 100px">
              筛选
            </el-button>
          </el-form-item>
        </el-form>
        <!-- 表格 -->
        <div class="table-data table">
          <el-table :data="tableseData" style="width: 100%" v-loading="tableLoding">
            <template slot="empty">
              <!-- 没有数据 -->
              <NoData></NoData>
              <br />
            </template>
            <el-table-column label="姓名">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.custom_name ? scope.row.custom_name : '-' }}
                </div>
                <div style="color: #909399">
                  {{ scope.row.representative_code ? scope.row.representative_code : '-' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="bu" label="BU" />
            <el-table-column prop="superior_dsm_name" label="上级" />
            <el-table-column prop="area" label="区域" />
            <!-- <el-table-column prop="type" label="代表类型" /> -->
            <el-table-column prop="phone" label="手机号" />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="presentGoback(scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <el-pagination
          class="pagination"
          style="background-color: #ffffff"
          layout="total,sizes, prev, pager, next, jumper"
          :total="total"
          :page-size="presentsize"
          :current-page="currentPage"
          :page-sizes="g_pageSizesConfig"
          @current-change="CurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <!-- <div>
      <div class="release-list-noData">
        <img class="release-list-noData-img" :src="g_imgSrc.bgWhite" />
        <div class="release-list-noData-word">您暂无权限</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import NoData from '@/components/no-data';
import { getRepresentativeListApi } from '@/api/setUp.js';
export default {
  name: 'RepresentManagement',
  components: {
    NoData,
  },
  data() {
    return {
      // 搜索表单
      bottonLoading: false,
      tableLoding: false,
      form: {
        input: '',
      },
      // 表格数据
      tableseData: [],
      // 分页
      total: 0,
      presentsize: 10,
      currentPage: 1,

      role: 1,
    };
  },
  created() {
    this.presentsize = this.g_pageSizeDefault;
    this.requestListData();
    // this.getLoginerInfo();
  },
  methods: {
    // 获取操作员相关信息
    getLoginerInfo() {
      this.role = this.$store.state.user.managerLogin.role;
    },
    requestListData() {
      this.tableLoding = true;
      const req = {
        page_size: this.presentsize,
        page_index: this.currentPage,
        param: this.form.input,
      };
      getRepresentativeListApi(req)
        .then((res) => {
          this.tableseData = res.list;
          this.total = res.total;
          this.tableLoding = false;
          this.bottonLoading = false;
        })
        .catch(() => {
          this.$message('筛选失败');
          this.tableLoding = false;
          this.bottonLoading = false;
        });
    },
    search() {
      this.bottonLoading = true;
      this.requestListData();
    },
    // 代表的查看详情
    presentGoback({ id }) {
      this.g_tourl(`/saas/representDetaill.html?id=${id}`);
    },
    // 页码改变
    CurrentChange(val) {
      this.currentPage = val;
      this.tableLoding = true;
      this.requestListData();
    },
    handleSizeChange(val) {
      this.tableLoding = true;
      this.currentPage = 1;
      this.presentsize = val;
      this.requestListData();
    },
  },
};
</script>

<style scoped lang="scss">
@import './index.scss';
</style>
